import React from 'react';

import {
  MessageBubbleActionList,
  MessageBubbleHeaderText,
  MessageBubbleActionItem,
} from 'src/commons/components/MessageBubble';

const HINT_PREFIX = 'yearly-individual-income-hint';

export const YearlyIncomeHintContents = () => (
  <MessageBubbleActionList
    id={`${HINT_PREFIX}-list`}
    role="list"
    aria-details={`annualIncome ${HINT_PREFIX}-do-list ${HINT_PREFIX}-do-item-0 ${HINT_PREFIX}-do-item-1 ${HINT_PREFIX}-do-item-2 ${HINT_PREFIX}-do-item-3 ${HINT_PREFIX}-do-item-4 ${HINT_PREFIX}-dont-list ${HINT_PREFIX}-dont-item-0`}
  >
    <MessageBubbleHeaderText id={`${HINT_PREFIX}-do-list`}>
      You can include:
    </MessageBubbleHeaderText>
    <MessageBubbleActionItem
      id={`${HINT_PREFIX}-do-item-0`}
      isPositiveAction
      actionText="Your yearly earnings, before taxes"
    />
    <MessageBubbleActionItem
      id={`${HINT_PREFIX}-do-item-1`}
      isPositiveAction
      actionText="Bonuses, commissions, and variable pay"
    />
    <MessageBubbleActionItem
      id={`${HINT_PREFIX}-do-item-2`}
      isPositiveAction
      actionText="Retirement, disability, pension, benefits, or public assistance income"
    />
    <MessageBubbleActionItem
      id={`${HINT_PREFIX}-do-item-3`}
      isPositiveAction
      actionText="Rental income"
    />
    <MessageBubbleActionItem
      id={`${HINT_PREFIX}-do-item-4`}
      isPositiveAction
      actionText="Alimony, child support, or separate maintenance income are optional"
    />
    <MessageBubbleHeaderText id={`${HINT_PREFIX}-dont-list`}>
      Don’t include:
    </MessageBubbleHeaderText>
    <MessageBubbleActionItem
      id={`${HINT_PREFIX}-dont-item-0`}
      isPositiveAction={false}
      actionText="Income from other members of your household"
    />
  </MessageBubbleActionList>
);
